import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return <div className="footer">Made with &#10084; by N.D. ©2022</div>;
  }
}
